import lengthConfig from '../config/length';

import validateLength from './length';

const validateDescription = (value: string): string =>
    validateLength(value, lengthConfig.description, 'field-description');

export default validateDescription;
